<template>
  <div>
    <v-btn v-if="activity === 'create'" icon @click="dialog = true, game = item, isUpdating = false">
      <v-icon color="primary">fa-file-plus</v-icon>
    </v-btn>
    <v-btn v-if="activity === 'read'" icon @click="dialog = true, game = item, isUpdating = false">
      <v-icon color="info">fa-folder-open</v-icon>
    </v-btn>
    <v-btn v-if="activity === 'update'" icon @click="dialog = true, game = item, isUpdating = true">
      <v-icon color="success">fa-edit</v-icon>
    </v-btn>
    <v-btn v-if="activity === 'delete'" icon @click="dialog = true, game = item, isRemoving = true">
      <v-icon color="error">fa-trash-alt</v-icon>
    </v-btn>
    <!-- Dialogs -->
    <alfakodo-dialog :dialog="dialog && alfakodo" :game="alfakodo" :isUpdating="isUpdating" :isRemoving="isRemoving" @cancel="cancel()">
    </alfakodo-dialog>
    <target-time-dialog :dialog="dialog && targettime" :game="targettime" :isUpdating="isUpdating" :isRemoving="isRemoving" @cancel="cancel()">
    </target-time-dialog>
    <jumble-word-dialog :dialog="dialog && jumbleword" :game="jumbleword" :isUpdating="isUpdating" :isRemoving="isRemoving" @cancel="cancel()">
    </jumble-word-dialog>
    <client-dialog :dialog="dialog && client" :client="client" :isUpdating="isUpdating" :isRemoving="isRemoving" @cancel="cancel()" @callback="logoCallback">
    </client-dialog>
  </div>
</template>

<script>
  import alfakodoDialog from '@/dialogs/diaAlfakodo'
  import targetTimeDialog from '@/dialogs/diaTargetTime'
  import jumbleWordDialog from '@/dialogs/diaJumbleWord'
  import clientDialog from '@/dialogs/diaClient'

  export default {
    props: [
      "item",
      "activity",
    ],
    data() {
      return {
        game: [],
        dialog: false,
        isUpdating: false,
        isRemoving: false
      }
    },
    computed: {
      alfakodo() {
        // Check if game is an Alfakodo otherwise return false
        if(this.game.revealed) {
          return this.game
        }
        return false
      },
      targettime() {
        if(this.game.target) {
          console.log(this.game.name)
          var type = this.getType(this.game.name)
          if (type == 'tt')
            return this.game
        }
        return false
      },
      jumbleword() {
        if(this.game.target) {
          var type = this.getType(this.game.name)
          if (type == 'j')
            return this.game
        }
        return false
      },
      client() {
        if(this.item.client) {
          if(!this.game.target && !this.game.revealed)
            return this.item.client
        }
        return false
      },
    },
    components: {
      alfakodoDialog,
      targetTimeDialog,
      jumbleWordDialog,
      clientDialog,
    },
    methods: {
      cancel() {
        this.dialog = false
        this.file = {}
        this.isUpdating = false
        this.isRemoving = false
      },
      logoCallback(url, clientId) {
        this.$emit('callback', url, clientId)
      },
      getType(name) {
        return name.match(/^[A-za-z]{1,2}[0-9]/)[0].replace(/[0-9]$/,"").toLowerCase()
      }
    }
  }
</script>